module.exports = __webpack_public_path__ + "static/media/heart.fa08ddf1.svg";